
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/add-circle","xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#697485"}},[_c('path',{attrs:{"d":"M8.5 16.103A7.594 7.594 0 013.131 3.131 7.594 7.594 0 1113.87 13.87a7.549 7.549 0 01-5.37 2.233zm0-14.144a6.542 6.542 0 106.542 6.542A6.549 6.549 0 008.5 1.959z"}}),_c('g',{attrs:{"data-name":"Group 687","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M11.372 9.038H5.628a.539.539 0 01-.539-.538.539.539 0 01.539-.539h5.744a.539.539 0 01.539.539.539.539 0 01-.539.538z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.5 11.91a.539.539 0 01-.539-.538V5.628a.539.539 0 01.539-.539.539.539 0 01.539.539v5.744a.539.539 0 01-.539.538z"}})])])])
          )
        }
      }
    